import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import logo from '../../assets/img/logo.png'
import styled from "styled-components";

const StyledAppBar = styled(AppBar)`
background-color: #fff;
`;

const StyledToolbar = styled(Toolbar)`
background-color: #fff;
height: 100px;
`;

const Logo = styled.img`
margin-left: auto;
margin-right: auto;
width: 200px;
`;

/**
 * Base VladLink header
 */
const Header = () => {
  return (
    <StyledAppBar position="static">
      <StyledToolbar>
        <Logo src={logo} alt="logo"/>
      </StyledToolbar>
    </StyledAppBar>
  );
};

export default Header;
